export default __webpack_public_path__ + "static/media/026-beach-ball.e2129cde.png";